/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { CustomModal } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { Typography, Form, Row, Col, Button, Input } from 'antd'
import { deleteAuthUser, resetDeleteAuthUserState } from 'src/features'
import { logout } from 'src/core/helpers'
import { useRouter } from 'next/router'
const { Text } = Typography

const DeleteAccountModal = ({ isModalVisible, setIsModalVisible }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const router = useRouter()

  const {
    loading: loadingDelete,
    success: successDelete,
    errorMessage
  } = useAppSelector((state) => state.users.deleteAuthUser)

  const handleCancel = () => {
    setIsModalVisible(false)
    dispatch(resetDeleteAuthUserState())
    form.resetFields()
  }

  const onFinish = ({ password }) => {
    dispatch(deleteAuthUser({ password }))
  }

  useEffect(() => {
    if (successDelete) {
      form.resetFields()
      logout(router)
    }
  }, [successDelete])

  const errorMessageLabel = () => {
    return errorMessage?.endsWith('OldPasswordIncorrect') ? t('settings.OldPasswordIncorrect') : 'Error'
  }

  return (
    <>
      <CustomModal
        title={t('settings.DeleteMyAccount')}
        footer={null}
        open={isModalVisible}
        onCancel={handleCancel}
      >
        <Form
          name='basic'
          onFinish={onFinish}
          autoComplete='off'
          form={form}
        >
          <Row>
            {/* Password */}
            <Col span={24}>
              <Text className='mb-2'>{t('settings.WritePassword')}</Text>
              <Form.Item
                name={'password'}
                rules={[{ required: true, message: t('general.RequiredValidation'), whitespace: true }]}
              >
                <Input.Password
                  placeholder={t('admin.Brokerage.PasswordPlaceHolder')}
                  size='large'
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Error Message */}
          {errorMessage !== null && <Text type='danger'>{errorMessageLabel()}</Text>}

          <Row className='is-align-content-center'>
            <Button
              htmlType='submit'
              size='large'
              className='radius-100'
              block
              danger
              ghost
              loading={loadingDelete}
            >
              {loadingDelete ? t('settings.DeletingAccount') : t('settings.deleteAccount')}
            </Button>
          </Row>
        </Form>
      </CustomModal>
    </>
  )
}
export default DeleteAccountModal
